export const NOVU_APP_CODE =
	import.meta.env.MODE === "production" ? "f26FZsVLXUcA" : "ak_4gHgiIZr0";
